import { Alert, IconButton } from "@mui/material";
import { closeSnackbar, CustomContentProps } from "notistack";
import React from "react";
import { PiXBold } from "react-icons/pi";

export const AlertSnackbar = React.forwardRef<
  HTMLDivElement,
  CustomContentProps
>(({ id, message, variant }, ref) => {
  return (
    <Alert
      ref={ref}
      severity={variant as "success" | "error" | "warning" | "info"}
      action={
        <IconButton
          sx={{ p: 1 }}
          color={variant as "success" | "error" | "warning" | "info"}
          size="small"
          onClick={() => closeSnackbar(id)}
        >
          <PiXBold />
        </IconButton>
      }
      sx={{ ".MuiAlert-action": { p: 0, pl: 1 } }}
    >
      {message}
    </Alert>
  );
});
